module.exports = __webpack_public_path__ + "img/Robert.dce967c2.jpg";